module.exports = __webpack_public_path__ + "img/mission_script_info.256f88aa.svg";